module.exports = __webpack_public_path__ + "img/violet_073.6d702db3.png";